import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Stack, Typography } from '@mui/material'
import { StyledContainer, StyledSuccessIcon, StyledTitle } from './styles'
import { RouteParameters, Route } from '../../../constants'
import { hydratePathname } from '../../../util'
import { useCountry, useIsIFramed } from '../../../hooks'
import { config } from '../../../config'

export const CreateAppointmentSuccess = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isIFramed = useIsIFramed()
  const country = useCountry()
  const { [RouteParameters.CUSTOMER_GID]: customerGid } = useParams()

  const onFinish = () => {
    if (isIFramed) {
      window.parent.postMessage({ type: 'APPOINTMENT_CREATED' }, config.PARTNER_PORTAL_NEO_URL || '*')
      window.parent.postMessage({ type: 'APPOINTMENT_CREATED' }, config.FLOW_CLIENT_URL || '*')
    }
  }

  const onCreateAnother = () => {
    const backPath = hydratePathname(Route.CREATE_APPOINTMENT, {
      [RouteParameters.COUNTRY]: country,
      [RouteParameters.CUSTOMER_GID]: customerGid,
    })

    navigate(backPath)
  }

  return (
    <StyledContainer>
      <Stack alignItems="center" spacing={3}>
        <StyledSuccessIcon color="success" />

        <StyledTitle variant="h4" data-testid="appointment-create-success-title">
          {t('createAppointment.successTitle')}
        </StyledTitle>

        <Typography variant="body1" textAlign="center" data-testid="appointment-create-success-message">
          {t('createAppointment.successMessage')}
        </Typography>

        <Button variant="contained" onClick={onFinish} data-testid="appointment-create-success-finish">
          {t('createAppointment.finish')}
        </Button>

        <Button variant="outlined" onClick={onCreateAnother} data-testid="appointment-create-success-create-another-button">
          {t('createAppointment.createAnother')}
        </Button>
      </Stack>
    </StyledContainer>
  )
}
